<template>
  <div class="reset-password-view container py-5 mt-5">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div v-if="key && email">
          <h1 class="text-center bold text-xl mb-5 text-uppercase">{{$t('auth.resetPassword')}}</h1>
          <div v-if="error" class="mb-4">
            <b-alert show variant="danger">
              <span class="text-sm">{{error}}</span>
            </b-alert>
          </div>
          <div class="form">
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <b-form @submit="onSubmit" @submit.stop.prevent>
                <div class="password-container mb-5">
                  <validation-provider rules="required|min:8" v-slot="{ errors }">
                    <b-input-group id="group-password">
                      <b-input-group-prepend is-text>
                        <b-icon icon="key"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input id="password"
                                    class="text-sm"
                                    v-model="form.password"
                                    :placeholder="$t('auth.typeNewPassword')"
                                    :type="!isPasswordVisible ? 'password' : 'text'"
                                    required
                      ></b-form-input>
                      <b-input-group-append is-text @click="tooglePasswordVisibility" class="pointer">
                        <b-icon v-if="!isPasswordVisible" icon="eye"></b-icon>
                        <b-icon v-if="isPasswordVisible" icon="eye-slash"></b-icon>
                      </b-input-group-append>
                    </b-input-group>
                    <span class="form-error text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="button-container d-flex justify-content-center">
                  <b-button type="submit"
                            :disabled="invalid || formSending"
                            variant="primary"
                            class="btn-rounded px-5 py-2 d-flex justify-content-center align-items-center">
                    <span class="text-md text-uppercase">{{$t('auth.setNewPassword')}}</span>
                    <b-spinner v-if="formSending" type="grow" small class="ml-3"></b-spinner>
                  </b-button>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, min } from 'vee-validate/dist/rules';
import { i18n } from 'vue-lang-router';

extend('required', {
  ...required,
  message: i18n.t('forms.thisFieldIsRequired'),
});
extend('min', {
  ...min,
  message: i18n.t('forms.atLeastCharacters'),
});

export default {
  metaInfo() {
    return {
      title: `${this.$t('auth.resetPassword')} - Nissens Support`,
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      key: null,
      email: null,
      form: {
        password: '',
      },
      formSending: false,
      error: '',
      isPasswordVisible: false,
    };
  },
  mounted() {
    if (this.$route.query.key && this.$route.query.email) {
      this.key = this.$route.query.key;
      this.email = this.$route.query.email;
      if (this.$store.state.user.status.loggedIn) {
        this.$store.dispatch('user/LOGOUT');
      }
    } else {
      this.$router.push('/');
    }
  },
  methods: {
    onSubmit() {
      this.$refs.observer.validate().then(() => {
        this.formSending = true;
        const data = {
          email: this.email,
          code: this.key,
          new_password: this.form.password,
        };
        this.$store.dispatch('user/RESET_PASSWORD', data)
          .then(() => {
            this.formSending = false;
            this.$root.$bvToast.toast('Success', {
              title: this.$t('auth.passwordChanged'),
              variant: 'light',
              solid: true,
              autoHideDelay: 7000,
              toaster: 'b-toaster-bottom-center',
              bodyClass: 'd-none',
              toastClass: 'toast-secondary',
            });
            this.$router.push('/login');
          })
          .catch((error) => {
            this.formSending = false;
            this.form.password = '';
            this.error = error;
          });
      });
    },
    tooglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.reset-password-view ::v-deep {
  form {
    .input-group-prepend > div {
      background-color: white;
    }
    input {
      padding: .8rem 1rem;
      height: unset;
      border-right: 0;
    }
    svg {
      color: #c7c7c7;
    }
  .input-group-append .input-group-text {
      background-color: transparent;
      border-left: 0;
    }
  }
  .password-container {
    margin-bottom: 50px;
  }
  .button-container {
    display: flex;
    justify-content: center;
  }
  .form-error {
    color: $tertiary;
  }
}
</style>
